import { zodResolver } from '@hookform/resolvers/zod';
import { FieldValues, useForm, UseFormProps } from 'react-hook-form';
import { ZodType } from 'zod';

export const buildFormWithZodHook =
  <FormValues extends FieldValues>(schema: ZodType<FormValues>) =>
  (props: Omit<UseFormProps<FormValues, unknown>, 'resolver'>) => {
    const form = useForm<FormValues, unknown>({
      ...props,
      resolver: zodResolver(schema),
    });

    return form;
  };
